import { LiveSearchWebComponent } from './component/LiveSearchWebComponent';

export { LiveSearchWebComponent };
